import axios from "axios";
import store from "@/store/index";
import $config from "@/config/index";
import QS from "qs";

// 线上环境配置axios.defaults.baseURL，生产环境则用proxy代理

console.log("请求前缀", $config.baseURL);
if (process.env.VUE_APP_ENV_NAME !== "development") {
  axios.defaults.baseURL = $config.baseURL;
}
axios.defaults.headers["Content-Type"] = "application/json;charse=UTF-8";
axios.defaults.timeout = 10000; // 超时时间

//请求拦截器
axios.interceptors.request.use(
  (config) => {
    /**
     * 处理不同环境中接口路径别名问题
     * 在config中配置别名
     * */
    if (config.method !== "get") {
      // 全局 POST请求拦截
      store.commit("OPEN_LOADING");
    }
    if ($config.pathRewrite && typeof $config.pathRewrite === "object") {
      for (let key in $config.pathRewrite) {
        config.url = config.url.replace(key, $config.pathRewrite[key]);
      }
    }

    config.headers.appId = $config.appId;
    // config.headers.remote_user = store.getters.oauth.userCode;
    config.headers.Authorization =
      config.headers.Authorization || store.getters.authorization;
    // config.headers.Authorization =
    //   "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxODc4MDExODE5MSIsImlkZW50aXR5VHlwZSI6bnVsbCwiZXhwIjoxNjExMDQ3ODIyLCJqdGkiOjEzMzY5ODkxNTM5NTg2Nzg1MzB9.ScCqi5Fpk6zbuDkcXhxjvDztT_3LLmLK1lZsGnn4zqw";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(
  (response) => {
    store.commit("CLOSE_LOADING");
    // H5跟投权限跳转
    if (response.data.code === "40301") {
      store.dispatch("noPermisison");
      return;
    }
    if (response.data.status || response.data.appId) {
      return Promise.resolve(response.data);
    } else {
      // store.dispatch('showMassage', {
      // 	type: 'fail',
      // 	data: response.data.message || response.data.msg || response.data.errMsg
      // })
      return Promise.reject(
        response.data.message ||
          response.data.msg ||
          response.data.errMsg ||
          response.message
      );
    }
  },
  (err) => {
    console.log(err);
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = "错误请求";
          break;
        case 401:
          err.message = "未授权，请重新登录";
          store.dispatch("goLogin");
          break;
        case 403:
          err.message = "没有访问权限，拒绝访问";
          break;
        case 404:
          err.message = "请求错误,未找到该资源";
          break;
        case 405:
          err.message = "请求方法未允许";
          break;
        case 408:
          err.message = "请求超时";
          break;
        case 500:
          err.message =
            err.response.data.message || err.response.message || err.message;
          break;
        case 501:
          err.message = "网络未实现";
          break;
        case 502:
          err.message = "网络错误";
          break;
        case 503:
          err.message = "服务不可用";
          break;
        case 504:
          err.message = "网络超时";
          break;
        default:
          err.message = `连接错误${err.response.msg}`;
      }
    } else {
      err.message = "连接到服务器失败";
    }

    store.dispatch("showMassage", {
      type: "fail",
      message: err.message || err.response.msg || err.response.message,
    });
    return Promise.reject(err.response);
  }
);

export default {
  //get请求
  get(url, param, header) {
    return axios({
      method: "get",
      url,
      headers: {
        ...(header || {}),
      },
      params: param || {},
    });
  },
  //post请求
  post(url, param, header) {
    return axios({
      method: "post",
      url,
      headers: {
        ...(header || {}),
        "Content-Type": "application/json;charse=UTF-8",
      },
      data: param || {},
    });
  },
  postFormData(url, params, header) {
    return axios({
      method: "post",
      url,
      headers: {
        ...(header || {}),
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: QS.stringify(params) || {},
    });
  },
  //post请求
  put(url, param, header) {
    return axios({
      method: "put",
      url,
      headers: {
        ...(header || {}),
        "Content-Type": "application/json;charse=UTF-8",
      },
      data: param || {},
    });
  },
  // delete
  delete(url, param, header) {
    return axios({
      method: "delete",
      url,
      headers: {
        ...(header || {}),
      },
      params: param || {},
    });
  },
};
